import { t } from '@/utils/i18n'
import { Controller } from '@hotwired/stimulus'

export default class EmployeeFormController extends Controller {
  static targets = ['isForeignerInput', 'personalCodeLabel']

  connect() {
    if (!this.hasIsForeignerInputTarget) return
    this.updateLabel()
  }

  updateLabel() {
    if (!this.hasIsForeignerInputTarget || !this.hasPersonalCodeLabelTarget) return

    const labelText = this.isForeignerInputTarget.checked
      ? t('v2.employees.form.foreigner_personal_code_label')
      : t('activerecord.attributes.employee.personal_code')

    this.personalCodeLabelTarget.innerHTML = `${labelText} <abbr title="required">*</abbr>`
  }
}
